module.exports = __webpack_public_path__ + "static/img/course-pic@2x.039082b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/course-pic@2x.png
// module id = 949
// module chunks = 0